import { render, staticRenderFns } from "./phone-block-modal.vue?vue&type=template&id=3256b41e&scoped=true"
import script from "./phone-block-modal.vue?vue&type=script&lang=js"
export * from "./phone-block-modal.vue?vue&type=script&lang=js"
import style0 from "./phone-block-modal.vue?vue&type=style&index=0&id=3256b41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256b41e",
  null
  
)

export default component.exports